export const ADDONS_URL = process.env.REACT_APP_ADDONS_URL
export const ADDONS_ENABLED = process.env.REACT_APP_ADDONS_ENABLED

export const SHEETBRIDGE_URL =
  process.env.REACT_APP_SHEETBRIDGE_URL || 'http://localhost:8000'

export const SHEETBRIDGE_ID_COLUMN =
  process.env.REACT_APP_GOOGLE_SHEETS_ID_COLUMN || 'sheetbridge_id'

export const MANUAL_AUTH_PROVIDER = 'manual'
export const GOOGLE_AUTH_PROVIDER = 'google'
